/// <amd-module name="TFS/Admin/Views/AdminRoles/Redux/AdminRolesSaga" />
import { effects, SagaIterator } from "redux-saga";
import { AdminRolesActions, AdminRolesActionTypes } from "TFS/Admin/Views/AdminRoles/Redux/AdminRolesActions";
import { IVssPageContext } from "VSS/Platform/Context";

export function* adminRolesSaga(): SagaIterator {
    yield effects.takeEvery(AdminRolesActionTypes.InitView, initializeAdminRoles);
}

export function* initializeAdminRoles(): SagaIterator {
    const pageContext: IVssPageContext = (yield effects.getContext("pageContext")) as any;

    yield effects.put(AdminRolesActions.initialLoadSucceeded());
}
